import React from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';

type Props = {
    onConfirm: () => void,
    onClose: () => void,
};

export const ConfirmModal: React.FC<Props> = ({onConfirm, onClose}) => (
    <>
        <DialogHeader onClose={onClose}>
            Unsaved Changes
        </DialogHeader>
        <DialogMain style={{padding: 24}}>
            <div>
                Are you sure that you want to leave the current page? <br/>
                The changes that you made won't be saved.
            </div>
        </DialogMain>
        <DialogFooter>
            <Group>
                <Button variant="Type.PRIMARY" onClick={onConfirm}>
                    Leave page
                </Button>
                <Button variant="Type.SECONDARY" onClick={onClose}>
                    Cancel
                </Button>
            </Group>
        </DialogFooter>
    </>
);
